// extracted by mini-css-extract-plugin
export default {"root":"DocViewer_root__Z7+F-","iframe":"DocViewer_iframe__6NSZu"};